const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value) {
  return EMAIL_PATTERN.test(String(value || '').trim());
}

export function validateRequired(value, message) {
  if (value === null || value === undefined || String(value).trim() === '') {
    return message;
  }
  return null;
}

export function validateEmail(value, messages) {
  const required = validateRequired(value, messages.required);
  if (required) return required;
  if (!isValidEmail(value)) return messages.invalid;
  return null;
}

export function validatePassword(value, messages, minLength = 6) {
  const required = validateRequired(value, messages.required);
  if (required) return required;
  if (String(value).length < minLength) return messages.min;
  return null;
}

export function validatePasswordMatch(password, confirmPassword, message) {
  if (password !== confirmPassword) return message;
  return null;
}

export function validateFields(rules) {
  const errors = {};
  let valid = true;

  Object.entries(rules).forEach(([field, error]) => {
    if (error) {
      errors[field] = error;
      valid = false;
    }
  });

  return { valid, errors };
}

export function touchAllFields(fields) {
  return Object.fromEntries(Object.keys(fields).map((key) => [key, true]));
}
